<template>
  <Modal :modal="mfaLoginModalRef" :steps="[{ component: MfaLoginContent, id: 'mfa-login' }]" />
</template>

<script lang="ts" setup>
import MfaLoginContent from '@/features/auth/components/mfa-login-modal/mfa-login-content/mfa-login-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetMfaLoginModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const mfaLoginModalRef = selectGetMfaLoginModal(modalsStore)
</script>
